import {
  setupJsonJWTHeaders,
  genericHandleApiError,
  requestOk,
} from './api-util'
import { fetchWithTimeout } from '../util/fetch'
import config from '../../../config'

class CustomerFinderServiceApi {
  static getAddressInfo = (
    { governmentId, customerType, countryCode },
    token,
  ) => {
    const searchStr = {
      countryCode,
      customerType,
      governmentId,
    }

    const myInit = {
      method: 'POST',
      headers: setupJsonJWTHeaders(token),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body: JSON.stringify(searchStr),
    }

    return fetchWithTimeout(
      `${config.customerFinderServiceUrl}/v2/customers/searches`,
      myInit,
      config.requestTimeout,
      'Timeout',
    ).then(response => {
      if (requestOk(response)) {
        return response.json()
      }
      return genericHandleApiError(response)
    })
  }
}

export default CustomerFinderServiceApi
